// src/components/WhyChooseUs.jsx
import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { FaLaptopCode, FaUsers, FaLightbulb } from "react-icons/fa";
import { motion } from "framer-motion"; // ✅ Import Framer Motion
import "./WhyChooseUs.css";
import { Link } from "react-router-dom";

// Import your images
import img1 from "../assets/project-1.jpg";
import img2 from "../assets/project-2.jpg";
import img3 from "../assets/project-3.jpg";
import img4 from "../assets/project-4.jpg";
import img5 from "../assets/project-5.jpg";
import img6 from "../assets/project-6.jpg";
import img7 from "../assets/project-7.jpg";
import img8 from "../assets/project-8.jpg";
import img9 from "../assets/project-9.jpg";
import img10 from "../assets/project-10.jpeg";

// ✅ Animation variants
const containerVariants = {
  hidden: { opacity: 0, x: -100 },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
      staggerChildren: 0.3, // Delay between children
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, x: -50 },
  show: { opacity: 1, x: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const WhyChooseUs = () => {
  return (
    <section className="why-choose-us py-5">
      <Container>
        <Row className="align-items-center">
          {/* ✅ Left Content with stagger animation */}
          <Col md={6}>
            <motion.div
              variants={containerVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0.2 }}
            >
              <motion.p
                className="section-subtitle"
                variants={itemVariants}
              >
                WHY CHOOSE US
              </motion.p>

              <motion.h2
                className="section-title1 mb-4"
                variants={itemVariants}
              >
               Strat Edge Project<br /> Management  Made Simple.
              </motion.h2>

              <motion.div
                className="feature-box mb-4 d-flex"
                variants={itemVariants}
              >
                <div className="icon">
                  <FaLaptopCode />
                </div>
                <div>
                  <h5>Full Lifecycle Expertise</h5>
                  <p>
                   From business case development to deployment, testing, training, and support.
                  </p>
                </div>
              </motion.div>

              <motion.div
                className="feature-box mb-4 d-flex"
                variants={itemVariants}
              >
                <div className="icon">
                  <FaUsers />
                </div>
                <div>
                  <h5>Proven Delivery Record</h5>
                  <p>
                    Over 40+ successful projects across healthcare IT, retail, telecom, and government digitization.
                  </p>
                </div>
              </motion.div>

              <motion.div
                className="feature-box mb-4 d-flex"
                variants={itemVariants}
              >
                <div className="icon">
                  <FaLightbulb />
                </div>
                <div>
                  <h5>Dual Capability</h5>
                  <p>
                   Rare expertise in both *digital transformation* and *physical infrastructure deployment.
                  </p>
                </div>
              </motion.div>

              <motion.div variants={itemVariants}>
                <Link to="/about">
  <Button className="btn-custom">Read More</Button>
</Link>
              </motion.div>
            </motion.div>
          </Col>

          {/* Right Side Dual Column Slider */}
          <Col md={6}>
            <div className="dual-slider">
              {/* Left column - scroll up */}
              <div className="slider-column up">
                <img src={img1} alt="img1" />
                <img src={img2} alt="img2" />
                <img src={img3} alt="img3" />
                <img src={img4} alt="img4" />
                <img src={img5} alt="img5" />
                {/* duplicate for infinite loop */}
                <img src={img6} alt="img6" />
                <img src={img7} alt="img7" />
                <img src={img8} alt="img8" />
                <img src={img9} alt="img9" />
                <img src={img10} alt="img10" />
              </div>

              {/* Right column - scroll down */}
              <div className="slider-column down">
                <img src={img2} alt="img2" />
                <img src={img3} alt="img3" />
                <img src={img4} alt="img4" />
                <img src={img5} alt="img5" />
                <img src={img1} alt="img1" />
                {/* duplicate for infinite loop */}
                <img src={img6} alt="img6" />
                <img src={img7} alt="img7" />
                <img src={img8} alt="img8" />
                <img src={img9} alt="img9" />
                <img src={img10} alt="img10" />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default WhyChooseUs;
